import {
  AfterViewChecked,
  AfterViewInit,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef,
  forwardRef, HostListener,
  Inject,
  OnDestroy,
  OnInit, ViewChild,
} from '@angular/core';
import {
  SohoMessageService,
  SohoModalDialogService,
  SohoToastService
} from 'ids-enterprise-ng';
import { LMApplicationMenuService } from '@app/components';
import { LMErrorUtilService } from '@services/utils/lm-error-util.service';
import { LMLoggerService } from '@services/lm-logger.service';
import { LMUrlUtilService } from '@services/utils/lm-url-util.service';
import { LMLoginService } from '@login/lm-login.service';
import { LMActionFormDialogService } from '@modal/lm-action-form-dialog.service';
import { LMSpecService } from '@services/lm-spec.service';
import { LMContextService } from '@services/lm-context.service';
import { LMContextUtilService } from '@utils/lm-context-util.service';
import { LMReportPersonalizationDialogService } from '@modal/lm-report-personalization-dialog.service';
import { LMGlobalUtilService } from '@utils/lm-global-util.service';
import { LMGlobalPersonalizationService } from '@app/states';
import { LMApplicationMenuAsOfDateDialogService } from '@components/applicationmenu/asofdate/lm-application-menu-asofdate-dialog.service';
import { LMFormatUtilService } from '@services/utils/lm-format-util.service';
import { LMApplicationMenuSearchService } from '@components/applicationmenu/search/lm-application-menu-search.service';
import { LMBusyIndicatorService } from '@services/lm-busyindicator.service';
import { LMApplicationMenuUserContextDialogService } from '@app/components';
import { LMFormRequestService } from '@form/services/lm-form-request.service';
import { Router } from '@angular/router';
import { LMApplicationMenuBaseDirective } from '@components/applicationmenu/lm-application-menu-base.directive';
import { LMBrowserUtilService, LMUniqueIdService } from '@app/utils';
import { LMThemeService } from '@banner/lm-theme.service';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { LMRoamingUIProfileService, RoamingUIProfileResult, RoamingUIProfileResponse } from '@services/lm-roamingUIProfile.service';

@Component({
  selector:        'lm-application-menu',
  templateUrl:     'lm-application-menu.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrls:       [ 'lm-application-menu.component.scss' ],
  providers: [ LMRoamingUIProfileService ],
  animations: [
    trigger('paneDisplay', [
      state('block', style({
        display: 'block',
      })),
      state('none', style({
        display: 'none',
      }))
    ]),
  ],
})
export class LMApplicationMenuComponent extends LMApplicationMenuBaseDirective implements OnInit, AfterViewInit, AfterViewChecked, OnDestroy {
  @ViewChild('AppMenuSwitcher') appMenuSwitcher: ElementRef;
  @ViewChild('ExpandablePane') expandablePane: ElementRef;
  @ViewChild('AppMenuContent') appMenuContent: ElementRef;
  @ViewChild('ActionMenu') actionMenu: ElementRef;
  @ViewChild('SettingsGuide') settingsGuide: ElementRef;
  @ViewChild('AppSwitcherGuide') appSwitcherGuide: ElementRef;

  @HostListener('click', [ '$event' ]) onClick(event) {
    let closeActionMenu = true;

    const eventPath = (event?.composedPath && event?.composedPath()) || event?.path;
    eventPath?.forEach((element) => {
      if (element?.classList?.contains('lm-application-action-menu') ||
          element?.classList?.contains('lm-application-menu-settings-btn')
      ) {
        closeActionMenu = false;
      }
    });

    if(closeActionMenu && this.actionMenuIsOpen) {
      this.closeActionMenu();
    }
  };

  public actionMenuIsOpen = false;
  public displayMenuGuide = this.showMenuGuide();

  constructor(
    protected sohoModalDialogService: SohoModalDialogService,
    protected sohoToastService: SohoToastService,
    protected lmAsOfDateService: LMApplicationMenuAsOfDateDialogService,
    protected lmContextService: LMContextService,
    protected lmApplicationMenuService: LMApplicationMenuService,
    protected lmFormRequestService: LMFormRequestService,
    protected lmFormatUtilService: LMFormatUtilService,
    protected lmSpecService: LMSpecService,
    protected lmErrorUtilService: LMErrorUtilService,
    protected lmLoggerService: LMLoggerService,
    protected lmUrlUtilService: LMUrlUtilService,
    protected lmGlobalUtilService: LMGlobalUtilService,
    protected lmLoginService: LMLoginService,
    protected lmContextUtilService: LMContextUtilService,
    protected lmReportPersonalizationDialogService: LMReportPersonalizationDialogService,
    protected lmGlobalPersonalizationService: LMGlobalPersonalizationService,
    protected lmUniqueIdService: LMUniqueIdService,
    protected sohoMessageService: SohoMessageService,
    protected lmApplicationMenuSearchService: LMApplicationMenuSearchService,
    protected lmBusyIndicatorService: LMBusyIndicatorService,
    protected lmUserContextService: LMApplicationMenuUserContextDialogService,
    protected lmRoamingUIProfileService: LMRoamingUIProfileService,
    protected lmBrowserUtilService: LMBrowserUtilService,
    @Inject(forwardRef(() => LMActionFormDialogService)) protected lmActionFormDialogService, // LMActionFormDialogService,
    protected changeDetectorRef: ChangeDetectorRef,
    protected router: Router,
    protected lmThemeService: LMThemeService
  ) {
    super(
      sohoModalDialogService,
      sohoToastService,
      lmAsOfDateService,
      lmContextService,
      lmApplicationMenuService,
      lmFormRequestService,
      lmFormatUtilService,
      lmSpecService,
      lmErrorUtilService,
      lmLoggerService,
      lmUrlUtilService,
      lmGlobalUtilService,
      lmLoginService,
      lmContextUtilService,
      lmReportPersonalizationDialogService,
      lmGlobalPersonalizationService,
      lmUniqueIdService,
      sohoMessageService,
      lmApplicationMenuSearchService,
      lmBusyIndicatorService,
      lmUserContextService,
      lmActionFormDialogService,
      changeDetectorRef,
      router,
      lmRoamingUIProfileService,
      lmThemeService
    );
  }

  public onAppMenuSwitcherClicked(e: Event) {
    this.toggleRoleSwitcherPanel();

    // Prevent app menu from closing
    e?.stopImmediatePropagation();
  }

  public onSelectRole(event) {
    this.selectRole(event);
    this.toggleRoleSwitcherPanel();
  }

  public toggleActionMenu() {
    this.actionMenu.nativeElement.style.display = this.actionMenuIsOpen ? 'none' : 'block';
    this.actionMenuIsOpen = !this.actionMenuIsOpen;
  }

  public dismissSettingsGuide() {
    this.settingsGuide.nativeElement.style.display = 'none';
    this.appSwitcherGuide.nativeElement.style.display = 'flex';
  }

  public dismissAppSwitcherGuide() {
    this.appSwitcherGuide.nativeElement.style.display = 'none';
    this.lmRoamingUIProfileService.setMenuV2Viewed()
      .subscribe(
        (results: RoamingUIProfileResponse) => {
          if (results.status === RoamingUIProfileResult.COMPLETED) {
            this.lmLoggerService.log('RoamingUIProfile Updated');
          }
        });
  }

  private showMenuGuide(): boolean {
    if (this.lmBrowserUtilService.isMobile || this.lmContextService.isAnonymousUser()) {
      return false;
    }

    const context = this.lmContextService.getContext();
    const webProfile = context.roamingUIProfile ? context.roamingUIProfile : {};

    if (context.showMenuGuide) {
      if (webProfile) {
        if (webProfile.menuV2GuideViewed === undefined || !webProfile.menuV2GuideViewed) {
          return true;
        } else {
          return false;
        }
      }
    } else {
      return false;
    }
  }

  public closeActionMenu() {
    this.actionMenu.nativeElement.style.display = 'none';
    this.actionMenuIsOpen = false;
  }

  public toggleRoleSwitcherPanel(): void {
    this.rolesPaneIsOpen = !this.rolesPaneIsOpen;
  }
}
